<template>
  <nav>
    <v-row class="fill-height" align="center" v-if="!loadingData">
      <v-col cols="12" sm="10" md="8" offset-sm="1" offset-md="2" align="center">
        <v-form ref="form" v-model="valid"  @submit.prevent>
          <AlertMessages v-if="alertValue" alert-type="error" :alert-msg="alertMsg" @reset="alertValue = false" />
          <v-card max-width="800" elevation="0" rounded="xxl" color="background">
            <v-card-title class="text-h5 font-weight-bold text-center no-break justify-center mb-4">
              {{ $t('createContactTitle') }}
            </v-card-title>
            <v-card-text>
                
                <v-row>
               
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="firstName"
                                        data-testid="first-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createCustomerPersonFirstNamePlaceholder')"
                                        :rules="firstNameRules"
                                        @keyup.enter="focusNext($event.target)"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="lastName"
                                        data-testid="last-name-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createCustomerPersonLastNamePlaceholder')"
                                        :rules="lastNameRules"
                                        @keyup.enter="focusNext($event.target)"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="email"
                                        data-testid="email-input"
                                        solo
                                        hide-details="auto"
                                        class="rounded-xxl text-body-2"
                                        :placeholder="$t('createCustomerPersonEmailPlaceholder')"
                                        :rules="emailRules"
                                        @keyup.enter="focusNext($event.target)"
                                    />
                                </v-col>
                </v-row>        
            </v-card-text>
          </v-card>
          <v-row>
            <v-col align="center">
              <FormFooter next-button-text="create" :loading="loading" @proceedSubmit="createCustomerContact" />
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters, descriptionRuleValidMin, descriptionRuleValidMax, emailRuleValid  } from '../../rules/formRules.js';
import i18n from '../../plugins/i18n'
import { createCustomerContact } from '../../api/productApi'
import FormFooter from '../../components/FormFooter'
import AlertMessages from '../../components/AlertMessages'

export default {
  components: {
    FormFooter, 
    AlertMessages
  },
  data() {
    return {
      valid: true,
      title: '',
      titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
      description: '',
      descriptionRules: descriptionRuleValidMin.concat(descriptionRuleValidMax),
      alertMsg: '',
      buttonDisabled: false,

      alertValue: false,
      loadingData: false,
    
      firstName: '',
      firstNameRules: ruleRequired('labelFirstName').concat(ruleValidMin2Max70Characters('labelFirstName')),
      lastName: '',
      lastNameRules: ruleRequired('labelLastName').concat(ruleValidMin2Max70Characters('labelLastName')),
      email: '',
      emailRules: ruleRequired('labelEmail').concat(emailRuleValid),
      storeCustomerID: this.$route.params.id,
    }
  },
  computed: {
    loading() {
      if (this.buttonDisabled) {
        return true
      }
      return false
    },
    productPlan() {
      return this.$store.state.productPlan;
    },
     formattedPrice: {
      get() {
        return this.price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true, style: 'decimal' }).replace(',', '.');
      },
      set(value) {
        this.price = parseFloat(value.replace('.', ''));
      },
    },
  },
  watch: {
  
  },

  async created(){
    this.loadingData = true
    this.loadingData = false
  },
  methods: {
    
    async createCustomerContact() {
      this.$refs.form.validate()
      if(this.valid){
      this.buttonDisabled = true
      
       try {
          let data = {
            data: {
              type: "store-customer-contacts",
              attributes: {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
              },
              relationships: {
                "store-customer": {
                  data: {
                    type: "store-customers",
                    id: "" + this.storeCustomerID + ""
                  },
                },
              }
            }
          };
          var response = await createCustomerContact(data);

          if (response) {
            if (response.status == 201) {
             this.$router.push({ name: 'ViewStoreCustomer', params: { id: this.storeCustomerID , successfullyCreateCustomerContact: true } })
            }
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            if (e.response.status == 403) {
              this.$router.push({ name: 'PageAccessDenied' })
            } else if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The email has already been taken.'){
                                    this.alertType = i18n.t('error')
                                    this.alertMsg = i18n.t('theEmailHasAlreadyBeenTaken')
                                }else{
                                    this.alertType = i18n.t('error')
                                    this.alertMsg =  i18n.t('serverError')
                                }
                            }
                        }else {
              this.alertValue = true
              this.alertMsg = i18n.t('serverError')
            }
          } else {
            this.alertMsg = i18n.t('serverError')
          }
        }
     this.buttonDisabled = false
    }
    },
    
  }
}
</script>
